import { createSlice } from '@reduxjs/toolkit';

const accountsDetailsSlice = createSlice({
  name: 'accountsDetails',
  initialState: {
    credentials: [],
    companies: [],
    invoices: [],
    credentialsCounts: 0,
    companiesCounts: 0,
    invoicesCounts: 0,
    editCredentials: {},
    editCompanies: {},
    editInvoices: {},
    addUpdateCredentialSuccess: false,
    addUpdateCompaniesSuccess: false,
    addUpdateInvoicesSuccess: false,
    gst: null,
    pan: null,
    verifyGstStatus: false,
    verifyPanStatus: false,
  },
  reducers: {
    fetchAccountCredential(state, action) { 
      state.credentials = action.payload;
    },
    fetchAccountInvoices(state, action) { 
      state.invoices = action.payload;
    },
    fetchVerifyGstStatus(state, action) { 
      state.verifyGstStatus = action.payload;
    },
    fetchVerifyPanStatus(state, action) { 
      state.verifyPanStatus = action.payload;
    },
    fetchAccountCompanies(state, action) { 
      state.companies = action.payload;
    },
    fetchInvoicesCount(state, action) { 
      state.invoicesCounts = action.payload ? action.payload: 0;
    },
    fetchCredentialsCount(state, action) { 
      state.credentialsCounts = action.payload ? action.payload: 0;
    },
    fetchCompaniesCount(state, action) { 
      state.companiesCounts = action.payload ? action.payload: 0;
    },
    fetchAddUpdateInvoicesSuccess(state, action) { 
      state.addUpdateInvoicesSuccess = action.payload;
    },
    fetchAddUpdateCredentialSuccess(state, action) { 
      state.addUpdateCredentialSuccess = action.payload;
    },
    fetchAddUpdateCompaniesSuccess(state, action) { 
      state.addUpdateCompaniesSuccess = action.payload;
    },
    fetchEditInvoices(state, action) { 
      state.editInvoices = action.payload;
    },
    fetchEditCredentials(state, action) { 
      state.editCredentials = action.payload;
    },
    fetchEditCompanies(state, action) { 
      state.editCompanies = action.payload;
    },
  },
});

export const {
  fetchAccountInvoices, fetchInvoicesCount, fetchAddUpdateInvoicesSuccess, fetchEditInvoices,
  fetchVerifyGstStatus, fetchVerifyPanStatus, fetchAccountCredential, fetchAccountCompanies, fetchCompaniesCount, fetchCredentialsCount, 
  fetchEditCompanies, fetchEditCredentials, fetchAddUpdateCompaniesSuccess, fetchAddUpdateCredentialSuccess} = accountsDetailsSlice.actions;

export default accountsDetailsSlice.reducer;